import { render, staticRenderFns } from "./StatusMobileListManagementView.vue?vue&type=template&id=8b85af06&scoped=true&"
import script from "./StatusMobileListManagementView.vue?vue&type=script&lang=js&"
export * from "./StatusMobileListManagementView.vue?vue&type=script&lang=js&"
import style0 from "./StatusMobileListManagementView.vue?vue&type=style&index=0&id=8b85af06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b85af06",
  null
  
)

export default component.exports